import { Components, Theme } from "@mui/material";
import { Colors } from "style/Colors";
import { FONT_BADGE_SIZE, FONT_FAMILY } from "./constant";

export const MuiBadge: Components<Theme>["MuiBadge"] = {
  styleOverrides: {
    root: {
      width: "10px",
      "&.bg-orange": {
        "& .MuiBadge-badge": {
          backgroundColor: Colors.orange,
          fontWeight: "bold",
          fontSize: "12px",
        },
      },

      "&.bg-greenDark": {
        "& .MuiBadge-badge": {
          backgroundColor: Colors.accentGreenLight,
        },
      },
    },
    badge: {
      fontFamily: FONT_FAMILY,
      fontSize: FONT_BADGE_SIZE,
    },
    anchorOriginTopRightRectangular: {
      backgroundColor: Colors.greenDark,
      fontWeight: "bold",
    },
  },
};
